import type { ApiResponse } from "@deltabeacon/contracts";

const API_BASE =
  (import.meta.env.VITE_API_URL as string | undefined)?.replace(/\/$/, "") ??
  "";
let csrfToken: string | null = null;

export class ApiClientError extends Error {
  constructor(
    message: string,
    public code: string,
    public status: number,
    public fieldErrors?: Record<string, string[]>,
  ) {
    super(message);
  }
}

export function setCsrfToken(value: string | null) {
  csrfToken = value;
}

export function adminApiUrl(path: string) {
  return `${API_BASE}/api/admin/v1${path}`;
}

export async function api<T>(
  path: string,
  options: RequestInit = {},
): Promise<T> {
  const body = await apiResponse<T>(path, options);
  return body.data;
}

export async function apiResponse<T>(path: string, options: RequestInit = {}) {
  const method = options.method?.toUpperCase() ?? "GET";
  const response = await fetch(adminApiUrl(path), {
    ...options,
    credentials: "include",
    headers: {
      "content-type": "application/json",
      ...(csrfToken && !["GET", "HEAD", "OPTIONS"].includes(method)
        ? { "x-csrf-token": csrfToken }
        : {}),
      ...options.headers,
    },
  });
  const body = (await response
    .json()
    .catch(() => null)) as ApiResponse<T> | null;
  if (!response.ok || !body?.success) {
    const failure = body && !body.success ? body.error : null;
    throw new ApiClientError(
      failure?.message ?? "服务暂时不可用，请稍后重试。",
      failure?.code ?? "REQUEST_FAILED",
      response.status,
      failure?.fieldErrors,
    );
  }
  return body;
}

export function queryString(
  input: Record<string, string | number | undefined>,
) {
  const params = new URLSearchParams();
  for (const [key, value] of Object.entries(input)) {
    if (value !== undefined && value !== "") params.set(key, String(value));
  }
  return `?${params.toString()}`;
}
